function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "63.044%",
  y1: "50%",
  x2: "-41.155%",
  y2: "50%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE9D7",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFAE86",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "20.658%",
  x2: "50%",
  y2: "100%",
  id: "c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE3A4",
  stopOpacity: 0.999,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC94F",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "26.687%",
  x2: "50%",
  y2: "108.267%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD475",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9B562",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "52.876%",
  y2: "41.662%",
  id: "f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB356",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9B562",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "220.299%",
  y1: "50%",
  x2: "0%",
  y2: "50%",
  id: "i"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE9D7",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFAE86",
  offset: "100%"
})), /*#__PURE__*/React.createElement("circle", {
  id: "b",
  cx: 25,
  cy: 25,
  r: 18.301
}), /*#__PURE__*/React.createElement("circle", {
  id: "g",
  cx: 23.5,
  cy: 23.5,
  r: 17.203
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFE9D7",
  d: "M.42 34.5h76.984v44H.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.407 43.929h70.5v11h-70.5a5.5 5.5 0 0 1 0-11z",
  fill: "url(#a)",
  transform: "translate(-.487 -14.929)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.846 12.09)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#c)",
  transform: "rotate(30 25 25)",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "url(#d)",
  mask: "url(#e)",
  transform: "rotate(30 25 25)",
  cx: 25,
  cy: 25,
  r: 15.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "url(#f)",
  opacity: 0.2,
  mask: "url(#e)",
  transform: "rotate(30 25 25)",
  cx: 25,
  cy: 25,
  r: 15
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.877 26.226c-.684-12.2-6.784-18.301-18.302-18.301-11.517 0-17.618 6.1-18.301 18.301h36.603z",
  fill: "#FFF",
  opacity: 0.1,
  mask: "url(#e)",
  transform: "rotate(30 29.575 17.075)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-30 15.75 5.195)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#c)",
  transform: "rotate(30 23.5 23.5)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFD475",
  mask: "url(#h)",
  transform: "rotate(30 23.5 23.5)",
  cx: 23.5,
  cy: 23.5,
  r: 14.57
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.004 24.652C44.362 13.184 38.627 7.45 27.801 7.45c-10.827 0-16.561 5.735-17.203 17.203h34.406z",
  fill: "#FFF",
  opacity: 0.1,
  mask: "url(#h)",
  transform: "rotate(30 27.8 16.05)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.42 40h73c9.389 0 17 7.611 17 17v26c0 9.389-7.611 17-17 17h-56c-9.389 0-17-7.611-17-17V40z",
  fill: "#FFE9D7"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(68.5 60)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0h22v20H10C4.477 20 0 15.523 0 10S4.477 0 10 0z",
  fill: "url(#i)"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFBF5",
  cx: 10,
  cy: 10,
  r: 5
})));

function SvgImgEmptyStateWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmptyStateWallet);
export default __webpack_public_path__ + "static/media/img_empty_state_wallet.eb339799.svg";
export { ForwardRef as ReactComponent };